module.exports = __webpack_public_path__ + "static/vol2-1a57db0484917f12b0605b4c966f7f19.png";